import { render, staticRenderFns } from "./EmployeeLeavesHistory.vue?vue&type=template&id=6c6b6160"
import script from "./EmployeeLeavesHistory.vue?vue&type=script&lang=js"
export * from "./EmployeeLeavesHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports